// extracted by mini-css-extract-plugin
export default {"host":"ButtonBack_host__FUBAn"};